export {
  default as SVGIcon,
  VALID_ICONS as VALID_SVG_ICONS,
  ISVGIconProps,
  SVGIconStyleWrapper,
} from './SVGIcon';
